module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Investindo no Amor")]), _vm._v(" "), _c('h1', [_vm._v("Lexy Timms")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "large",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Traduzido por Ju Pinheiro ")]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "font-size": "small",
      "page-break-before": "always"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene with-quote character-i"
  }, [_vm._v("“I")]), _vm._v("nvestindo no Amor”")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Escrito por Lexy Timms")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Copyright © 2022 Lexy Timms")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Todos os direitos reservados")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Distribuído por Babelcube, Inc. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("www.babelcube.com ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Traduzido por Ju Pinheiro")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Design da capa © 2022 Book Cover by Design")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("“Babelcube Books” e “Babelcube” são marcas comerciais da Babelcube Inc.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_c('img', {
    staticClass: "section-break-symbol",
    attrs: {
      "alt": "image",
      "height": "130",
      "src": "d2d_images/image013.png",
      "width": "257"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Copyright 2018")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "419",
      "src": "d2d_images/image002.jpg",
      "width": "280"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_c('img', {
    staticClass: "section-break-symbol",
    attrs: {
      "alt": "image",
      "height": "113",
      "src": "d2d_images/image004.png",
      "width": "114"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "font-size": "x-small",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-t"
  }, [_vm._v("T")]), _vm._v("odos os direitos reservados")]), _vm._v(". Nenhuma parte desta publicação pode ser reproduzida, armazenada ou introduzida em um sistema de recuperação ou transmitida, de qualquer maneira ou por quaisquer meios (eletrônico, mecânico, fotocópia, gravação ou outro) sem a autorização prévia por escrito de ambos, o proprietário dos direitos autorais e da editora, acima mencionada, deste livro.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-small",
      "text-align": "justify"
    }
  }, [_vm._v("Esta é uma obra de ficção. Nomes, personagens, lugares, marcas, mídia e incidentes são produtos da imaginação da autora ou são usados ficticiamente. Qualquer semelhança com uma pessoa real, viva ou morta, eventos ou locais, é mera coincidência. A autora reconhece o status de marca registrada e proprietários de marca registrada dos vários produtos citados nesta obra de ficção que tenham sido usados sem permissão. A publicação/uso destas marcas registradas não está autorizada, associada ou patrocinada pelos proprietários da marca registrada.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26f13440","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c001.vue
// module id = 60
// module chunks = 0